export default __webpack_public_path__ + "static/media/how_it_works_illustration_mobile.e538d970.png";